import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosInstance } from "../axiosSettings";
import { logout } from "./authSlice";

const initialState = {
  isLoading: false,
  notifications : [],
  notificationData : null,
  error : null
};


export const NOTIFICATION_UTR = "/admin/notification";

export const createNotification = createAsyncThunk(
    NOTIFICATION_UTR + "/create",
    async (formData, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        const response = await axiosInstance.post(NOTIFICATION_UTR, formData);
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(response.data.message || "Error");
        }
      } catch (error) {
        return rejectWithValue(
          error.response?.data?.message || "Error"
        );
      }
    }
);

export const getNotifications = createAsyncThunk(
    NOTIFICATION_UTR + "/get",
    async (formData, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        const response = await axiosInstance.get(NOTIFICATION_UTR, {
          params: formData
        });
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(response.data.message || "Error");
        }
      } catch (error) {
        return rejectWithValue(
          error.response?.data?.message || "Error"
        );
      }
    }
);

const notificationSlice = createSlice({
    name : "notification",
    initialState,
    extraReducers : (builder) => {
        builder
            .addCase(createNotification.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(createNotification.fulfilled, (state, action) => {
                state.isLoading = false;
                state.notificationData = action.payload;
            })
            .addCase(createNotification.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(getNotifications.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getNotifications.fulfilled, (state, action) => {
                state.isLoading = false;
                state.notifications = action.payload;
            })
            .addCase(getNotifications.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(logout, () => initialState)
    }
})

export default notificationSlice.reducer